export default __webpack_public_path__ + "3e91a222164c9b40f31d73552c8ea5d9.svg";